import React, { ReactNode, SyntheticEvent } from 'react'
import styled from 'styled-components'
import RouterLink from 'shared/components/router/link'
import { trackEvent, Actions } from 'shared/util/gif-detail-ga-events'

const Inactive = styled.span`
    opacity: 0.5;
    pointer-events: none;
`

type Props = {
    gif: any
    children?: ReactNode
    className?: string
    gaAction: string
}

const NextPrev = ({ gif, children, className, gaAction }: Props) => {
    return gif ? (
        <RouterLink
            className={`${className}`}
            onClick={(e: SyntheticEvent<HTMLElement, Event>) => {
                e.preventDefault()
                trackEvent(Actions[gaAction], gif.id)
            }}
            href={gif.path}
        >
            {children}
        </RouterLink>
    ) : (
        <Inactive className={`${className}`}>{children}</Inactive>
    )
}

export default NextPrev
